export default "__VITE_ASSET__Dno2PIKy__ 400w, __VITE_ASSET__DtHOJvOl__ 800w, __VITE_ASSET__Dvl_YwUT__ 1024w";